import * as tslib_1 from "tslib";
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import showInImmersiveReader from 'owa-immersive-reader-store/lib/actions/showInImmersiveReader';
import { action } from 'satcheljs/lib/legacy';
export default action('showConversationInImmersiveReader')(function (conversationId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var itemId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLatestNonDraftItemIdFromConversation(conversationId)];
                case 1:
                    itemId = _a.sent();
                    if (itemId) {
                        showInImmersiveReader(itemId);
                    }
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=showConversationInImmersiveReader.js.map